<ap-amount-input
    data-testid="monthlyIncome"
    [description]="'income.input.monthlyIncome.description' | apKeyOverride: contentKeyMap() | apContent"
    [numberOfDecimals]="numberOfDecimals()"
    [formControl]="form().controls.monthlyIncome | apFormControl"
    [label]="'income.input.monthlyIncome.label' | apKeyOverride: contentKeyMap() | apContent"
    [helpText]="'income.input.monthlyIncome.helpText' | apKeyOverride: contentKeyMap() | apContent"
    [messages]="monthlyIncomeErrorMessages"
></ap-amount-input>

<ap-radio-group
    [description]="'income.input.monthlyIncome.description' | apKeyOverride: contentKeyMap() | apContent"
    [descriptionHidden]="true"
    [control]="form().controls.frequency | apFormControl"
    data-testid="income-frequency"
>
    <ap-radio-button
        [label]="'income.input.monthly' | apKeyOverride: contentKeyMap() | apContent"
        name="frequency"
        value="monthly"
        [formControl]="form().controls.frequency | apFormControl"
    >
    </ap-radio-button>
    <ap-radio-button
        [label]="'income.input.fourWeekly' | apKeyOverride: contentKeyMap() | apContent"
        name="frequency"
        value="fourWeekly"
        [formControl]="form().controls.frequency | apFormControl"
    >
    </ap-radio-button
></ap-radio-group>

<fieldset>
    <legend class="ap-heading-3">{{ 'income.input.extra' | apKeyOverride: contentKeyMap() | apContent }}</legend>
    <ap-checkbox
        data-testid="hasVacationPayment"
        label="{{ 'income.input.optionVacationPayment' | apKeyOverride: contentKeyMap() | apContent }}"
        [formControl]="form().controls.hasVacationPayment | apFormControl"
        class="hasVacationPayment"
    ></ap-checkbox>
    <ap-checkbox
        data-testid="hasThirteenthMonthPayment"
        label="{{ 'income.input.optionThirteenthMonthPayment' | apKeyOverride: contentKeyMap() | apContent }}"
        [formControl]="form().controls.hasThirteenthMonthPayment | apFormControl"
        class="hasThirteenthMonthPayment"
    ></ap-checkbox>
    <ap-checkbox
        data-testid="hasBonusPayment"
        label="{{ 'income.input.optionBonusPayment' | apKeyOverride: contentKeyMap() | apContent }}"
        [formControl]="form().controls.hasBonusPayment | apFormControl"
        class="hasBonusPayment"
    ></ap-checkbox>
</fieldset>

@if (form().get('hasBonusPayment').value) {
    <ap-amount-input
        data-testid="bonusPayment"
        [numberOfDecimals]="numberOfDecimals()"
        [formControl]="form().controls.bonusPayment | apFormControl"
        [helpText]="'income.input.bonusPayment.helpText' | apKeyOverride: contentKeyMap() | apContent"
        [label]="'income.input.bonusPayment.label' | apKeyOverride: contentKeyMap() | apContent"
        [messages]="bonusPaymentErrorMessages"
    ></ap-amount-input>
}
